import EngagementToolCommon from "./engagement-tool-common";
import {
  EngagementChart,
  SuperTool,
  SuperEngagementTool,
  ICESuperIntegration,
} from "../mixin";
import { CommonHelper } from "../helpers";
import {
  AdvanceSuperFilter,
  RepaymentOptionList,
  PensionOption,
  OptionIndex,
  FeeTypeIndex,
} from "../helpers/constant";
import { mapGetters, mapActions } from "vuex";
import {
  GET_SUPERANNUATION_CHART_MODEL,
  SET_SUPERANNUATION_CHART_MODEL,
} from "../helpers/vuex-constants";
import _ from "lodash";
export default {
  mixins: [
    SuperTool,
    SuperEngagementTool,
    EngagementChart,
    EngagementToolCommon,
    ICESuperIntegration,
  ],
  data() {
    return {
      chartData: [],

      isNotShowGraph: true,
      linePlotData: [],
      advanceChartContainer: "chart-container",
    };
  },
  computed: {
    ...mapGetters("superannuation", {
      projectionModel: GET_SUPERANNUATION_CHART_MODEL,
    }),

    projectionYear() {
      return { Value: this.baselineData.projectionYear };
    },
  },
  mounted() {
    this.remapAllSuperAdvanceGraph();
  },
  methods: {
    ...mapActions("superannuation", {
      setsuperchartModel: SET_SUPERANNUATION_CHART_MODEL,
    }),
    removeRow() {
      this.getinsertEmptyRows(this.rows);
      this.RemoveError(
        this.baselineFilterObject.Errors,
        this.rows[0].typeId.value
      );
      this.infoText = [];
    },
    RemoveError(Errors, typeid) {
      if (typeid == AdvanceSuperFilter.Accumulation) {
        Errors["Accumulation"] = [];
      } else if (typeid == AdvanceSuperFilter.Contribution) {
        Errors["Contribution"] = [];
      } else if (typeid == AdvanceSuperFilter.Pension) {
        Errors["Pension"] = [];
      } else if (typeid == AdvanceSuperFilter.WithdrawalAccumulation) {
        Errors["WithdrawalAccumulation"] = [];
      } else if (typeid == AdvanceSuperFilter.WithdrawalPension) {
        Errors["WithdrawalPension"] = [];
      } else if (typeid == AdvanceSuperFilter.PensionPayment) {
        Errors["PensionPayment"] = [];
      } else if (typeid == AdvanceSuperFilter.FeeAccumulation) {
        Errors["FeeAccumulation"] = [];
      } else if (typeid == AdvanceSuperFilter.FeePension) {
        Errors["FeePension"] = [];
      } else {
        Errors["MarketCrash"] = [];
      }
    },
    PushErrors(Errors, typeid, subType, error, clientId) {
      if (typeid == AdvanceSuperFilter.Return) {
        Errors.Return.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.Accumulation) {
        Errors.Accumulation.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.Contribution) {
        Errors.Contribution.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.Pension) {
        Errors.Pension.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.WithdrawalAccumulation) {
        Errors.WithdrawalAccumulation.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.WithdrawalPension) {
        Errors.WithdrawalPension.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.PensionPayment) {
        Errors.PensionPayment.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.FeeAccumulation) {
        Errors.FeeAccumulation.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else if (typeid == AdvanceSuperFilter.FeePension) {
        Errors.FeePension.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      } else {
        Errors.MarketCrash.push({
          type: subType,
          typeid: typeid,
          clientid: clientId,
          error: error,
        });
      }
    },
    SetErrors(row, key, IsError, ErrorText = [""]) {
      row[key].IsError = IsError;
      row[key].ErrorText = ErrorText;
    },

    IsAnySuperOptionHaveInvalidData(errorSuperOption) {
      if (errorSuperOption.Accumulation.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.Accumulation,
          typeId: this.getMenuType(AdvanceSuperFilter.Accumulation),
          clientId: errorSuperOption.Accumulation[0].clientid,
        });
        return true;
      } else if (errorSuperOption.Contribution.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.Contribution,
          typeId: this.getMenuType(AdvanceSuperFilter.Contribution),
          clientId: errorSuperOption.Contribution[0].clientid,
        });
        return true;
      } else if (errorSuperOption.Pension.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.Pension,
          typeId: this.getMenuType(AdvanceSuperFilter.Pension),
          clientId: errorSuperOption.Pension[0].clientid,
        });
        return true;
      } else if (errorSuperOption.WithdrawalPension.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.WithdrawalPension,
          typeId: this.getMenuType(AdvanceSuperFilter.WithdrawalPension),
          clientId: errorSuperOption.WithdrawalPension[0].clientid,
        });
        return true;
      } else if (errorSuperOption.WithdrawalAccumulation.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.WithdrawalAccumulation,
          typeId: this.getMenuType(AdvanceSuperFilter.WithdrawalAccumulation),
          clientId: errorSuperOption.WithdrawalAccumulation[0].clientid,
        });
        return true;
      } else if (errorSuperOption.MarketCrash.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.MarketCrash,
          typeId: this.getMenuType(AdvanceSuperFilter.MarketCrash),
          clientId: errorSuperOption.MarketCrash[0].clientid,
        });
        return true;
      } else if (errorSuperOption.PensionPayment.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.PensionPayment,
          typeId: this.getMenuType(AdvanceSuperFilter.PensionPayment),
          clientId: errorSuperOption.PensionPayment[0].clientid,
        });
        return true;
      } else if (errorSuperOption.FeePension.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.FeePension,
          typeId: this.getMenuType(AdvanceSuperFilter.FeePension),
          clientId: errorSuperOption.FeePension[0].clientid,
        });
        return true;
      } else if (errorSuperOption.FeeAccumulation.length > 0) {
        this.$emit("openErrorTab", {
          subTypeId: AdvanceSuperFilter.FeeAccumulation,
          typeId: this.getMenuType(AdvanceSuperFilter.FeeAccumulation),
          clientId: errorSuperOption.FeeAccumulation[0].clientid,
        });
        return true;
      } else {
        return false;
      }
    },
    superValidations(tabdata, typeid, clientId) {
      let fields = this.singleHeadingOptions;
      let headers = this.headers;
      let rows = [];
      rows = tabdata.filter(
        (sr) =>
          sr.typeId.value == typeid &&
          (sr.clientID.value == clientId || sr.clientID.value == undefined)
      );
      let blankdataError = false;
      let hasRangeError = false;

      let Errors = {
        hasErrors: false,
        Accumulation: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Accumulation
          : [],
        Contribution: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Contribution
          : [],
        WithdrawalPension: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.WithdrawalPension
          : [],
        WithdrawalAccumulation: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.WithdrawalAccumulation
          : [],
        Pension: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Pension
          : [],
        MarketCrash: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.MarketCrash
          : [],
        PensionPayment: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.PensionPayment
          : [],
        FeePension: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.FeePension
          : [],
        FeeAccumulation: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.FeeAccumulation
          : [],
      };
      if (rows.length > 0) {
        this.RemoveError(Errors, typeid);
        for (let i = 0; i < rows.length; i++) {
          let subType = rows[i].subTypeId.value;
          let startMonth = "",
            startYear = "",
            endMonth = "",
            endYear = "";
          for (
            let h = 0;
            h < headers.filter((x) => x.type != "Icon").length;
            h++
          ) {
            let headername = headers[h].key;
            if (headername == "startDate") {
              startMonth = CommonHelper.getMonthfromMonthYear(
                rows[i].startDate.value == undefined ||
                  rows[i].startDate.value == ""
                  ? ""
                  : rows[i].startDate.value
              );
              startYear = CommonHelper.getYearfromMonthYear(
                rows[i].startDate.value == undefined ||
                  rows[i].startDate.value == ""
                  ? ""
                  : rows[i].startDate.value
              );
            }
            if (headername == "endDate") {
              endMonth = CommonHelper.getMonthfromMonthYear(
                rows[i].endDate.value == undefined ||
                  rows[i].endDate.value == ""
                  ? ""
                  : rows[i].endDate.value
              );
              endYear = CommonHelper.getYearfromMonthYear(
                rows[i].endDate.value == undefined ||
                  rows[i].endDate.value == ""
                  ? ""
                  : rows[i].endDate.value
              );
            }
            if (
              headers[h].validation == true &&
              fields
                .filter((x) => x.key == rows[i].subTypeId.value)[0]
                .fields.filter(
                  (x) => x.toLowerCase() == headername.toLowerCase()
                ).length > 0
            ) {
              // if (
              //   !rows[i][headername].disable  &&
              //   (rows[i][headername].value == "" ||
              //   rows[i][headername].value == "0") && (headername !== "amount1" && typeid == AdvanceSuperFilter.WithdrawalPension
              //   rows[i][headername].value == "0") && (headername !== "amount1" && typeid == AdvanceSuperFilter.WithdrawalPension
              //   && rows[i].superTypeId !== undefined ?rows[i].superTypeId !== 2 : rows[i].superTypeId == 0
              // )
              // ) {
              //   blankdataError = true;
              //   this.SetErrors(rows[i], headername, true);
              // }
              // }
              // else
              if (
                !rows[i][headername].disable &&
                (rows[i][headername].value == "" ||
                  rows[i][headername].value == "0")
              ) {
                blankdataError = true;
                this.SetErrors(rows[i], headername, true);
              } else {
                if (
                  headername == "startDate" &&
                  // rows[i].startDateType.value != 0 &&
                  rows[i].startDate.value.length != 7
                ) {
                  Errors.hasErrors = true;
                  blankdataError = true;
                  this.SetErrors(rows[i], headername, true);
                  this.PushErrors(
                    Errors,
                    typeid,
                    subType,
                    "Invalid Date",
                    clientId
                  );
                } else if (
                  headername == "endDate" &&
                  // rows[i].endDateType.value != 0 &&
                  rows[i].endDate.value.length != 7
                ) {
                  Errors.hasErrors = true;
                  blankdataError = true;
                  this.SetErrors(rows[i], headername, true);
                  this.PushErrors(
                    Errors,
                    typeid,
                    subType,
                    "Invalid Date",
                    clientId
                  );
                } else {
                  this.SetErrors(rows[i], headername, false);
                }
              }
            }
          }
          if (blankdataError) {
            let error = "All Fields are Required";
            Errors.hasErrors = true;
            this.PushErrors(Errors, typeid, subType, error, clientId);
          }

          startMonth = CommonHelper.getMonthfromMonthYear(
            rows[i].startDate.value == undefined ||
              rows[i].startDate.value == ""
              ? ""
              : rows[i].startDate.value
          );
          startYear = CommonHelper.getYearfromMonthYear(
            rows[i].startDate.value == undefined ||
              rows[i].startDate.value == ""
              ? ""
              : rows[i].startDate.value
          );
          endMonth = CommonHelper.getMonthfromMonthYear(
            rows[i].endDate.value == undefined || rows[i].endDate.value == ""
              ? ""
              : rows[i].endDate.value
          );
          endYear = CommonHelper.getYearfromMonthYear(
            rows[i].endDate.value == undefined || rows[i].endDate.value == ""
              ? ""
              : rows[i].endDate.value
          );
          if (
            CommonHelper.compareDates(
              startYear,
              startMonth,
              "01",
              endYear,
              endMonth,
              "01"
            ) &&
            !blankdataError &&
            startMonth != "" &&
            endMonth != "" &&
            fields.filter((x) => x.key == rows[i].subTypeId.value)[0]
              .overlapvalidations
          ) {
            Errors.hasErrors = true;
            this.SetErrors(rows[i], "startDate", true);
            this.SetErrors(rows[i], "endDate", true);
            if (!hasRangeError) {
              let Errormsg =
                "Start Date cannot be greater than or equal to End Date";
              this.PushErrors(Errors, typeid, subType, Errormsg, clientId);
            }
            hasRangeError = true;
          }
          if (!blankdataError) {
            for (let j = 0; j < rows.length; j++) {
              if (
                i != j &&
                fields.filter((x) => x.key == rows[i].subTypeId.value)[0]
                  .overlapvalidations &&
                fields.filter((x) => x.key == rows[j].subTypeId.value)[0]
                  .overlapvalidations
              ) {
                // let err =
                //   "Hit 'Tab' to move to the next cell and add a new row";
                // if (
                //   !CommonHelper.CompareOverlappingDates(
                //     startYear,
                //     startMonth,
                //     "01",
                //     endYear,
                //     endMonth,
                //     "01",
                //     CommonHelper.getYearfromMonthYear(
                //       rows[j].startDate.value == undefined ||
                //         rows[j].startDate.value == ""
                //         ? ""
                //         : rows[j].startDate.value
                //     ),
                //     CommonHelper.getMonthfromMonthYear(
                //       rows[j].startDate.value == undefined ||
                //         rows[j].startDate.value == ""
                //         ? ""
                //         : rows[j].startDate.value
                //     ),
                //     "01",
                //     CommonHelper.getYearfromMonthYear(
                //       rows[j].endDate.value == undefined ||
                //         rows[j].endDate.value == ""
                //         ? ""
                //         : rows[j].endDate.value
                //     ),
                //     CommonHelper.getMonthfromMonthYear(
                //       rows[j].endDate.value == undefined ||
                //         rows[j].endDate.value == ""
                //         ? ""
                //         : rows[j].endDate.value
                //     ),
                //     "01"
                //   ) &&
                //   rows[j].startDate.value != "" &&
                //   rows[j].endDate.value != ""
                // ) {
                //   this.SetErrors(rows[i], "startDate", true);
                //   this.SetErrors(rows[i], "endDate", true);
                //   Errors.hasErrors = true;
                //   err =
                //     "Overlapping time frame. To Proceed, review and edit to ensure no overlapping across periods";
                //   this.PushErrors(Errors, typeid, subType, err, clientId);
                // }
              }
            }
          }
        }
        this.infoError = Errors.hasErrors;
        if (Errors.hasErrors) {
          if (typeid == AdvanceSuperFilter.Accumulation) {
            this.infoText = Errors.Accumulation.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Accumulation = this.infoText;
          } else if (typeid == AdvanceSuperFilter.Pension) {
            this.infoText = Errors.Pension.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Pension = this.infoText;
          } else if (typeid == AdvanceSuperFilter.Contribution) {
            this.infoText = Errors.Contribution.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Contribution = this.infoText;
          } else if (typeid == AdvanceSuperFilter.WithdrawalAccumulation) {
            this.infoText = Errors.WithdrawalAccumulation.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.WithdrawalAccumulation = this.infoText;
          } else if (typeid == AdvanceSuperFilter.WithdrawalPension) {
            this.infoText = Errors.WithdrawalPension.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.WithdrawalPension = this.infoText;
          } else if (typeid == AdvanceSuperFilter.MarketCrash) {
            this.infoText = Errors.MarketCrash.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.MarketCrash = this.infoText;
          } else if (typeid == AdvanceSuperFilter.PensionPayment) {
            this.infoText = Errors.PensionPayment.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.PensionPayment = this.infoText;
          } else if (typeid == AdvanceSuperFilter.FeeAccumulation) {
            this.infoText = Errors.FeeAccumulation.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.FeeAccumulation = this.infoText;
          } else if (typeid == AdvanceSuperFilter.FeePension) {
            this.infoText = Errors.FeePension.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.FeePension = this.infoText;
          }
        } else {
          this.RemoveError(Errors, typeid);
          this.infoText = [];
        }
        let data = tabdata.filter(
          (sr) => sr.typeId.value != typeid || sr.clientID.value != clientId
        );
        let advancedetails = data.concat(rows);
          this.baselineFilterObject.superAddtionalDetails = advancedetails;
        this.baselineFilterObject.Errors = Errors;
        this.rows = this.emptyGridRow(rows);
        this.focusElementName = "";
        this.setErrorFocus();
      } else {
        this.RemoveError(Errors, typeid);
        this.baselineFilterObject.Errors = Errors;
      }
      this.getinsertEmptyRows(this.rows);

      return Errors.hasErrors;
    },
    getEditBaseLineButton(
      riskProfileOption,
      dropDownCallBack,
      changeInputCallBack
    ) {
      let editHeader = [];
      editHeader.push(
        this.createDropDownElement(
          "Risk Profile",
          "riskProfileId",
          riskProfileOption,
          4,
          dropDownCallBack
        )
      );
      editHeader.push(
        this.DefaultEditablePerElement(
          "Income",
          "incomeRate",
          2,
          99.99,
          changeInputCallBack,
          5
        )
      );
      editHeader.push(
        this.DefaultEditablePerElement(
          "Growth",
          "growthRate",
          2,
          99.99,
          changeInputCallBack,
          5
        )
      );
      editHeader.push(
        this.DefaultEditablePerElement(
          "Franking",
          "frankingRate",
          2,
          99.99,
          changeInputCallBack,
          5
        )
      );
      editHeader = editHeader.concat(this.getBaselineButton());
      return editHeader;
    },

    getContributionEditBaseLineButton() {
      let contributionEditHeader = [];

      contributionEditHeader.push(
        this.DefaultEditableCurrencyElement(
          "",
          "contributionAmount",
          4,
          999999999,
          "",
          9
        )
      );
      contributionEditHeader.push(
        this.createDropDownElement(
          "Frequency",
          "durationTypeId",
          RepaymentOptionList,
          4,
          ""
        )
      );

      contributionEditHeader = contributionEditHeader.concat(
        this.getBaselineButton()
      );
      return contributionEditHeader;
    },
    getPensionEditBaseLineButton() {
      let contributionEditHeader = [];

      contributionEditHeader.push(
        this.DefaultEditableCurrencyElement("", "amount", 5, 999999999, "", 9)
      );
      contributionEditHeader.push(
        this.createDropDownElement(
          "Frequency",
          "paymentType",
          PensionOption,
          4,
          ""
        )
      );

      contributionEditHeader = contributionEditHeader.concat(
        this.getBaselineButton()
      );
      return contributionEditHeader;
    },
    getBaselineButton() {
      let editSuperBaselineButton = [];
      editSuperBaselineButton.push(
        this.createButtonElement(
          "Save",
          "primary",
          "save",
          1,
          "saveBaseLineButton_Click"
        )
      );
      editSuperBaselineButton.push(
        this.createButtonElement(
          "Cancel",
          "flat",
          "cancel",
          1,
          "cancelBaseLineButton_Click"
        )
      );
      return editSuperBaselineButton;
    },
    getReturnBaselineHeader() {
      let headers = [];
      headers.push(
        this.DefaultReadOnlyElement("Risk Profile", "riskProfileName", 4)
      );
      headers.push(this.DefaultReadOnlyPerElement("Income", "incomeRate", 2));
      headers.push(this.DefaultReadOnlyPerElement("Growth", "growthRate", 2));
      headers.push(
        this.DefaultReadOnlyPerElement("Franking", "frankingRate", 2)
      );
      headers.push(this.createEditButtonElement());
      return headers;
    },
    getContributionBaselineHeader() {
      let headers = [];
      headers.push(
        this.DefaultReadOnlyPerCurrency("", "contributionAmount", 4)
      );
      headers.push(
        this.DefaultReadOnlyElement("Frequency", "durationTypeName", 4)
      );
      headers.push(this.createEditButtonElement());
      return headers;
    },

    getPensionBaselineHeader() {
      let headers = [];
      headers.push(this.DefaultReadOnlyPerCurrency("Amount", "amount", 4));
      headers.push(
        this.DefaultReadOnlyElement("Payment Type", "paymentTypeName", 4)
      );
      headers.push(this.createEditButtonElement());
      return headers;
    },

    cancelBaseLineButton_Click() {
      if (this.selectedOption == AdvanceSuperFilter.PensionPayment) {
        this.baselineRow.rows = this.getPensionbaselineRowData();
        this.baselineHeader = this.getPensionBaselineHeader();
      } else if (this.selectedOption == AdvanceSuperFilter.Contribution) {
        this.baselineRow.rows = this.getContributionbaselineRowData();
        this.baselineHeader = this.getContributionBaselineHeader();
      } else {
        this.baselineRow.rows = this.getbaselineRowData();
        this.baselineHeader = this.getReturnBaselineHeader();
      }
    },
    getbaselineSelectedIndex() {
      if (this.baselineFilterObject.fundDetails != undefined) {
        let fundDetailsIndex = this.baselineFilterObject.fundDetails.findIndex(
          (sr) =>
            sr.clientId == this.clientId && sr.fundType == this.selectedFundType
        );
        return fundDetailsIndex;
      }
    },

    getbaselineRowData() {
      if (this.getbaselineSelectedIndex() != undefined) {
        let selectedData =
          this.baselineFilterObject.fundDetails[
            this.getbaselineSelectedIndex()
          ];
        return this.resetRiskProfile(selectedData);
      }
    },
    getContributionbaselineRowData() {
      if (this.getbaselineSelectedIndex() != undefined) {
        let selectedData =
          this.baselineFilterObject.fundDetails[
            this.getbaselineSelectedIndex()
          ];
        return this.resetContributionRow(selectedData);
      }
    },

    getPensionbaselineRowData() {
      if (this.getbaselineSelectedIndex() != undefined) {
        let selectedData =
          this.baselineFilterObject.fundDetails[
            this.getbaselineSelectedIndex()
          ];

        return this.resetPensionRow(selectedData);
      }
    },
    getContributionRow(amount, label, durationTypeId) {
      let frequency = RepaymentOptionList.filter(
        (sr) => sr.value == durationTypeId
      );
      if (frequency.length == 0) {
        frequency = RepaymentOptionList[0];
      }
      return {
        contributionAmount: { value: amount, label: label },
        durationTypeId: { value: durationTypeId },
        durationTypeName: { value: frequency[0].text },
      };
    },

    resetRiskProfile(riskProfile) {
      let selectedRiskProfile = this.baselineData.riskProfileOption.filter(
        (sr) => sr.profileId == riskProfile.riskProfileId
      );
      if (selectedRiskProfile.length == 0) {
        selectedRiskProfile = this.baselineData.riskProfileOption.filter(
          (sr) => sr.profileId == 0
        );
      }
      return [
        {
          riskProfileId: { value: riskProfile.riskProfileId },
          incomeRate: {
            value: riskProfile.incomeRate,
          },
          growthRate: {
            value: riskProfile.growthRate,
          },
          frankingRate: {
            value: riskProfile.frankingRate,
          },
          riskProfileName: { value: selectedRiskProfile[0].text },
        },
      ];
    },
    editBaseLineButton_Click() {
      if (this.selectedOption == AdvanceSuperFilter.PensionPayment) {
        this.baselineHeader = this.getPensionEditBaseLineButton();
      } else if (this.selectedOption == AdvanceSuperFilter.Contribution) {
        this.baselineHeader = this.getContributionEditBaseLineButton();
      } else {
        this.baselineHeader = this.getEditBaseLineButton(
          this.baselineData.riskProfileOption,
          "changeRiskProfileId",
          "changeInputElement"
        );
      }
    },
    changeRiskProfileId(riskProfile) {
      riskProfile.riskProfileId = riskProfile.profileId;
      this.baselineRow.rows = this.resetRiskProfile(riskProfile);
    },
    changeInputElement(index) {
      this.baselineRow.rows[index].riskProfileId.value = 0;
    },
    saveBaseLineButton_Click(data) {
      if (this.selectedOption == AdvanceSuperFilter.PensionPayment) {
        this.saveBaselinePension(data);
      } else if (this.selectedOption == AdvanceSuperFilter.Contribution) {
        this.saveBaselineContribution(data);
      } else {
        this.saveBaselineReturn(data);
      }
    },

    saveBaselineReturn(data) {
      let selectedIndex = this.getbaselineSelectedIndex();
      if (
        this.baselineFilterObject.fundDetails[selectedIndex].incomeRate !=
          data[0].incomeRate.value ||
        this.baselineFilterObject.fundDetails[selectedIndex].growthRate !=
          data[0].growthRate.value ||
        this.baselineFilterObject.fundDetails[selectedIndex].frankingRate !=
          data[0].frankingRate.value ||
        this.baselineFilterObject.fundDetails[selectedIndex].riskProfileId !=
          data[0].riskProfileId.value
      ) {
        this.enableResetButton(false, "UpdateGraph");
      }
      this.baselineFilterObject.fundDetails[selectedIndex].incomeRate =
        data[0].incomeRate.value;
      this.baselineFilterObject.fundDetails[selectedIndex].growthRate =
        data[0].growthRate.value;
      this.baselineFilterObject.fundDetails[selectedIndex].frankingRate =
        data[0].frankingRate.value;
      this.baselineFilterObject.fundDetails[selectedIndex].riskProfileId =
        data[0].riskProfileId.value;
      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },

    saveBaselinePension(data) {
      let selectedIndex = this.getbaselineSelectedIndex();
      let pension =
        this.baselineFilterObject.fundDetails[selectedIndex].pensionPayment;
      if (
        pension.amount != data[0].amount.value ||
        pension.paymentType != data[0].paymentType.value
      ) {
        this.enableResetButton(false, "UpdateGraph");
      }
      pension.amount = data[0].amount.value;
      pension.paymentType = data[0].paymentType.value;
      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },

    saveBaselineContribution(data) {
      let selectedIndex = this.getbaselineSelectedIndex();
      let contribution =
        this.baselineFilterObject.fundDetails[selectedIndex].contribution;
      let i = 0;
      if (!contribution.isUseSGC) {
        if (
          contribution.employerAmount != data[0].contributionAmount.value ||
          contribution.employerDurationType != data[0].durationTypeId.value
        ) {
          this.enableResetButton(false, "UpdateGraph");
        }
        contribution.employerAmount = data[0].contributionAmount.value;
        contribution.employerDurationType = data[0].durationTypeId.value;
        i = 1;
      } else {
        if (
          contribution.salarySacrificeAmount !=
            data[i].contributionAmount.value ||
          contribution.salarySacrificeDurationType !=
            data[i].durationTypeId.value ||
          contribution.nonConcessionalAmount !=
            data[i + 1].contributionAmount.value ||
          contribution.nonConcessionalDurationType !=
            data[i + 1].durationTypeId.value
        ) {
          this.enableResetButton(false, "UpdateGraph");
        }
        contribution.salarySacrificeAmount = data[i].contributionAmount.value;
        contribution.salarySacrificeDurationType = data[i].durationTypeId.value;
        contribution.nonConcessionalAmount =
          data[i + 1].contributionAmount.value;
        contribution.nonConcessionalDurationType =
          data[i + 1].durationTypeId.value;
      }
      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },
    resetPensionRow(selectedData) {
      const pension = selectedData.pensionPayment;
      let pensionbaselineRowData = [];
      let pensionText = PensionOption.filter(
        (x) => x.value == pension.paymentType
      )[0].text;
      pensionbaselineRowData.push({
        amount: { value: pension.amount, label: "Amount" },
        paymentTypeName: { value: pensionText, label: "Pension Type" },
        paymentType: { value: pension.paymentType },
      });

      return pensionbaselineRowData;
    },
    resetContributionRow(selectedData) {
      const contribution = selectedData.contribution;
      let contributionbaselineRowData = [];
      if (!contribution.isUseSGC) {
        contributionbaselineRowData.push(
          this.getContributionRow(
            contribution.employerAmount,
            "Employer",
            contribution.employerDurationType
          )
        );
      }
      contributionbaselineRowData.push(
        this.getContributionRow(
          contribution.salarySacrificeAmount,
          "Salary Sacrifice",
          contribution.salarySacrificeDurationType
        )
      );
      contributionbaselineRowData.push(
        this.getContributionRow(
          contribution.nonConcessionalAmount,
          "Non-Concessional",
          contribution.nonConcessionalDurationType
        )
      );
      return contributionbaselineRowData;
    },
    reset(rows) {
      let typeId = 0;
      if (rows !== undefined) typeId = rows[0].typeId.value;
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let selectedRepData = Superannuations[0].superAddtionalDetails.filter(
        (sr) => sr.typeId == typeId && sr.clientID == this.clientId
      );
      if (selectedRepData.length > 0) {
        let advanceData = [];
        for (let i = 0; i < selectedRepData.length; i++) {
          advanceData.push({
            riskProfile: {
              value: selectedRepData[i].riskProfile,
            },
            amount2: {
              value: selectedRepData[i].amount2,
              disable: selectedRepData[i].option1 != OptionIndex.AmountOnly,
            },
            amount3: {
              value: selectedRepData[i].amount3,
              disable: selectedRepData[i].option1 != OptionIndex.PersentWithAmountCap,
            },
            subTypeId: {
              value: selectedRepData[i].subTypeId,
            },
            amount1: {
              value: selectedRepData[i].amount1,
              disable: selectedRepData[i].option1 == OptionIndex.AmountOnly  
            },
            startDate: {
              value: selectedRepData[i].startDate,
            },
            endDate: {
              value: selectedRepData[i].endDate,
            },
            description: {
              value: selectedRepData[i].description,
            },
            typeId: {
              value: typeId,
            },
            superTypeId: {
              value: selectedRepData[i].superTypeId,
            },
            index: {
              value: selectedRepData[i].index,
              disable: selectedRepData[i].option1 == OptionIndex.PersentOnly
            },
            frequency: {
              value: selectedRepData[i].frequency,
              disable: selectedRepData[i].option1 != OptionIndex.AmountOnly
            },
            startDateType: {
              value: selectedRepData[i].startDateType,
            },
            endDateType: {
              value: selectedRepData[i].endDateType,
            },
            effectiveAsOn: {
              value: selectedRepData[i].effectiveAsOn,
            },
            clientID: {
              value: selectedRepData[i].clientID,
            },
            option1: {
              value: selectedRepData[i].option1,
              disable: selectedRepData[i].superTypeId == FeeTypeIndex.Other,
            }
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = [];
      }
      this.getinsertEmptyRows(this.rows);
      this.RemoveError(this.baselineFilterObject.Errors, typeId);
      this.infoText = [];
      this.enableResetButton(false, "reset");
    },
    getIceInputData() {
      let iceInput = {
        fundDetails: this.baselineFilterObject.fundDetails,
        nonSuperData: this.baselineFilterObject.iceInput["nonSuperData"],
        otherDetail: this.baselineFilterObject.iceInput["otherDetail"],
        ownerDetails: this.baselineFilterObject.iceInput["ownerDetails"],
        referenceGuid: this.baselineFilterObject.iceInput.referenceGuid,
        superAddtionalDetails: this.baselineFilterObject.superAddtionalDetails,
        superfundDetails:
          this.baselineFilterObject.iceInput["superfundDetails"],
      };
      let advanceSuperInput = [];
      advanceSuperInput.push(iceInput);
      return advanceSuperInput;
    },
    async updateAllAdvanceSuperGraph(screenId, clientId) {
      this.fillSuperannuationModel(screenId, clientId);
      if (
        !this.superValidations(
          this.baselineFilterObject.superAddtionalDetails,
          screenId,
          clientId
        )
      ) {
        let userInput = this.getIceInputData();
        let apiResponse = await this.getProjectionDataFromIce("", userInput);
        this.baselineFilterObject.iceApiResponse = apiResponse;
        this.refreshAdvanceSuperGraphByOwner(
          this.baselineFilterObject.clientDetail,
          apiResponse,
          false,
          userInput
        );
      }
    },
    refreshAdvanceSuperGraphByOwner(
      clientDetail,
      iceAPiResponse,
      isShowEmptyState,
      userInput
    ) {
      this.setsuperchartModel(
        this.getSuperChartModel(
          clientDetail,
          iceAPiResponse,
          isShowEmptyState,
          userInput
        )
      );
      this.remapAllSuperAdvanceGraph();
    },
    setSuperAdvanceGraphFocus() {
      let chartContainer = this.$el.getElementsByClassName(
        this.advanceChartContainer
      );
      if (chartContainer && chartContainer.length > 0) {
        chartContainer[0].scrollIntoView({ behavior: "smooth" });
      }
    },
    remapData(data) {
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          data[i].amount = data[i].amount1;
          data[i].amount1 = data[i].amount2;
          data[i].amount2 = data[i].amount3;
        }
      }
      return data;
    },
    remapAllSuperAdvanceGraph() {
      if (this.projectionModel) {
        let data = [];
        if (
          this.clientId &&
          this.baselineFilterObject.superAddtionalDetails &&
          this.baselineFilterObject.superAddtionalDetails.length > 0
        ) {
          data = this.baselineFilterObject.superAddtionalDetails.filter(
            (sr) =>
              sr.typeId.value == this.selectedOption &&
              sr.clientID.value == this.clientId
          );
        } else if(this.baselineFilterObject.superAddtionalDetails) {
          data = this.baselineFilterObject.superAddtionalDetails.filter(
            (sr) => sr.typeId.value == this.selectedOption
          );
        }
        let cloneData = _.cloneDeep(data);
        data = this.remapData(cloneData);
        this.RemapSuperGraphsModel(
          data,
          this.selectedOption == AdvanceSuperFilter.Accumulation ||
            this.selectedOption == AdvanceSuperFilter.Pension
            ? true
            : false
        );
        this.isNotShowGraph = false;
        this.setSuperAdvanceGraphFocus();
      } else {
        this.isNotShowGraph = true;
      }
    },
  },
};
